import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Talent } from "../../talents/talentAPI";
import TalentSummaryCard from "./TalentSummaryCard";
import EmptyStateText from "./EmptyStateText";

type Props = {
  talent: Talent;
};

const TalentHrTasks = ({ talent }: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <Box bgcolor="#EAEAF1" mb={2} borderRadius="12px" overflow="hidden">
      <TalentSummaryCard
        title={t("profileSummary.hrTasks")}
        divider
        containerSx={{
          marginBottom: "0px",
          boxShadow: "0px 1px 8px 0px #52527A1F",
        }}
      >
        <EmptyStateText placeholder />
      </TalentSummaryCard>
    </Box>
  );
};

export default TalentHrTasks;
